"use strict";

export default class AdminController {
  /*@ngInject*/
  constructor(User) {}
}



// WEBPACK FOOTER //
// ./client/app/admin/admin.controller.js